import { FormEvent, useEffect, useState } from "react";
import Navigation from "../../header";
import { Button, Container, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { ShipmentService } from "../../../services/shipmentService";
import { IShipmentReportByVendorRequest, IShipmentReportByVendorRow } from "../../../types/shipment";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { ISelectOption } from "../../../types/list";
import { ICustomerLight } from "../../../types/customer";
import { CustomerService } from "../../../services/customerService";
import { UtilityService } from "../../../services/utilityService";
import Json from "../../json";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Form } from "react-router-dom";
import moment from "moment";
import PermissionGate from "../../permissionGate";
import { useUserContext } from "../../../contexts/userContext";

const ShipmentReportByVendor = () => {
	const [customerOptions, setCustomerOptions] = useState<ISelectOption[]>([]);
	const [formFields, setFormFields] = useState<IShipmentReportByVendorRequest>({
		customerId: 2406,
		startDate: new Date(),
		endDate: new Date(),
	});
	const [data, setData] = useState<IShipmentReportByVendorRow[]>([]);
	const userContext = useUserContext();
	
	useEffect(() => {
		getCustomerOptions();
	}, [])

	const getCustomerOptions = () => {
		//setIsLoadingCustomers(true);
		CustomerService.getCustomers()
			.then((response) => {
				console.log('CustomerService.getCustomers: SUCCESS', response);
				let options: ISelectOption[] = [];
				let activeCustomers = response.data.filter((item) => { return item.status == 'Active' });

				activeCustomers.map((item: ICustomerLight) => {
					if (item.name) {
						options.push({
							"name": item.name,
							"value": item.id
						})
					}
				});
				setCustomerOptions(options.sort((a, b) => UtilityService.compareStrings(a.name, b.name)));

				if (options.length > 0) {
					setFormFields({ ...formFields, ["customerId"]: parseInt(options[0].value) })
				}
			})
			.catch((error) => {
				console.log('CustomerService.getCustomers: ERROR', error);
			})
			.finally(() => {
			});
	}

	const handleStartDateChange = (value: Dayjs | null) => {
		if (value) {
			let newFields = formFields;
			newFields.startDate = value.toDate();
			setFormFields(newFields);
		}
	}

	const handleEndDateChange = (value: Dayjs | null) => {
		if (value) {
			let newFields = formFields;
			newFields.endDate = value.toDate();
			setFormFields(newFields);
		}
	}

	const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		ShipmentService.reportByVendor(formFields)
			.then((response) => {
				console.log('ShipmentService.reportByVendor: SUCCESS', response);
				const rows: IShipmentReportByVendorRow[] = [];
								let totalExpenseAmount = 0;
				
				response.data.map((item) => {
					let e: IShipmentReportByVendorRow = {
						customer: item.customer,
						vendor: item.vendor,
						date: item.date,
						hwiNumber: item.hwiNumber,
						category: item.category,
						name: item.name,
						amount: item.amount,
						amountUOM: item.amountUOM,
						hwiCredit: item.hwiCredit,
						hwiCreditUOM: item.hwiCreditUOM,
						hwiTotalCredit: item.hwiTotalCredit,
						hwiAmountAsPounds: item.hwiAmountAsPounds
					}

					rows.push(e);
				})

				setData(rows);
			})
			.catch((error) => {
				console.log('ShipmentService.reportByVendor: ERROR', error);
			})
			.finally(() => {
			});
	}





	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext?.permissions?.canViewReportShipmentByVendor}>
					<h1 className="report-header">Shipment Report by Vendor</h1>
					{/* <iframe role="presentation" width="1200" height="800" src="https://app.powerbi.com/rdlEmbed?reportId=94eaf07e-9e11-4902-b49b-fccd03c8a1c4&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2&experience=power-bi" frameBorder="1"></iframe> */}
					<embed width="1200" height="800" src="https://app.powerbi.com/rdlEmbed?reportId=94eaf07e-9e11-4902-b49b-fccd03c8a1c4&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2&experience=power-bi"></embed>
					{/* <br></br>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
					<Form onSubmit={(event) => handleSubmit(event)}>
						<div className="row">
							<InputLabel>Customer</InputLabel>
							<Select
								value={formFields.customerId}
								className="customer-field"
								required
								onChange={(event) => { setFormFields({ ...formFields, ["customerId"]: parseInt(event.target.value.toString()) }) }}
							>
								{customerOptions.map((item, index) => (
									<MenuItem value={item.value} key={index}>{item.name} ({item.value})</MenuItem>
								))}
							</Select>
						</div>

						<div className="row">
							<InputLabel>Start Date</InputLabel>
							<DatePicker className="start-date-field" value={dayjs(formFields.startDate)} onChange={(value) => handleStartDateChange(value)} />
						</div>
						<div className="row">
							<InputLabel>End Date</InputLabel>
							<DatePicker className="end-date-field" value={dayjs(formFields.endDate)} onChange={(value) => handleEndDateChange(value)} />
						</div>

						{data?.map((item, index) => (
							<div className="row" style={{display: 'flex'}} key={index}>
								<div className="col-brand" style={{flex: 2}}><p>{item.vendor}</p></div>
								<div className="col-state" style={{flex: 1}}><p>{moment(item.date).format('MM/DD/YYYY')}</p></div>
								<div className="col-city" style={{flex: 1}}><p>{item.hwiNumber}</p></div>
								<div className="col-status" style={{flex: 1}}><p>{item.category}</p></div>
								<div className="col-status" style={{flex: 2}}><p>{item.name}</p></div>
								<div className="col-status" style={{flex: 1}}><p>{item.amount}</p></div>
								<div className="col-status" style={{flex: 1}}><p>{item.amountUOM}</p></div>
								<div className="col-status" style={{flex: 1}}><p>{item.hwiCredit}</p></div>
								<div className="col-status" style={{flex: 1}}><p>{item.hwiCreditUOM}</p></div>
								<div className="col-status" style={{flex: 1}}><p>{item.hwiTotalCredit}</p></div>
								<div className="col-status" style={{flex: 1}}><p>{item.hwiAmountAsPounds}</p></div>
							</div>
						))}
						<div className="row controls">
							<Button type="submit" className="save-button" variant="contained">Submit</Button>
						</div>
					</Form>
				</LocalizationProvider> */}
				</PermissionGate>
			</Container>
		</>
	);
};

export default ShipmentReportByVendor;